export default "__VITE_ASSET__EZKOHwK5__"